import React, { useEffect, useState, useCallback, useContext } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { devices } from '@vr/lib/styles/theme';
import { IconButton } from '@material-ui/core';
import { H2, Icon } from '../../elements';
import { users as UsersApi } from '../../helpers/api';
import { ToastCtx } from '../../providers/ToastProvider';
import messages from '../../helpers/api/messages';
import Header from '../../compositions/Header';
import UserDataForm from '../../components/forms/UserDataForm';
import { Loader } from '../../components';
import { InternalContainer as CommonContainer } from '../common';
import { BreadcrumbsContext } from '~/providers/BreadcrumbsProvider';

const Container = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 32px;
  box-sizing: border-box;

  .back {
    display: flex;
    justify-content: center;
  }
`;

const Title = styled(H2)`
  margin-bottom: 35px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  .back-button {
    color: ${({ theme }) => theme.colors.white};
    margin-right: 10px;
    width: 48px;
    height: 48px;
    text-align: center;
  }

  @media (min-width: ${devices?.desktop}) {
    justify-content: center;
    .back-button {
      display: none;
    }
  }
`;

const EditUserData = () => {
  const history = useHistory();
  const user = useSelector(state => state.user);
  const toast = useContext(ToastCtx);
  const breadcrumbs = useContext(BreadcrumbsContext);
  const [userData, setUserData] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const getUserData = useCallback(async () => {
    try {
      setIsLoading(true);
      const data = await UsersApi.get({ cpf: user.cpf });

      setUserData(data);
    } catch (e) {
      toast.dispatch(messages(e.response?.data || e, 'register'), 'error');
    } finally {
      setIsLoading(false);
    }
    // eslint-disable-next-line
  }, []);

  function setBreadcrumb(icon, label) {
    breadcrumbs.setBreadcrumb({
      icon,
      label,
    });
  }

  useEffect(() => {
    setBreadcrumb('user-edit', 'Alterar dados pessoais');
    getUserData();
    return () => setBreadcrumb();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <CommonContainer>
        <Header />
      </CommonContainer>
      <Container>
        <Title color="white">
          <IconButton
            aria-label="Voltar para a página inicial"
            className="back-button"
            onClick={() => history.push('/home')}
          >
            <Icon icon={['far', 'angle-left']} />
          </IconButton>
          <span>Dados pessoais</span>
        </Title>

        <Loader isLoading={isLoading}>
          {userData && (
            <>
              <UserDataForm
                user={userData}
                onSave={() => history.push('/home')}
                setIsLoading={setIsLoading}
                isLoading={isLoading}
              />
            </>
          )}
        </Loader>
      </Container>
    </>
  );
};

EditUserData.defaultProps = {
  theme: {},
};

export default EditUserData;
